export enum LESSON_TYPE {

	CONTENT = 'content',
	VOCABULARY = 'vocabulary',
	EXERCISE = 'exercise',
	PHRASE = 'phrase',

}
